
import React from 'react';
import "./ColumnStates.scss";
import { Spinner } from '@swivl-mono/ui';
export function renderLoadingColumn() { return <div className="ColumnStates loadingColumn"  key={"loadingColumn"}><Spinner /></div>}
export function renderBlankState(icon?:any, title?:any, message?:any) {
  const iconView    = (icon)    ? <div className="icon">{icon}</div>    : null; 
  const titleView   = (title)   ? <div className="title">{title}</div>  : null; 
  const messageView = (message) ? <div className="message">{message}</div> : null; 

  return <div className="ColumnStates blankState"  key={"BlankState"}>
          <div className="blankStateContent">
              {iconView}
              {titleView}
              {messageView}
              </div>
              </div>
     }


    